export const CURRENCY_FORMAT = '#,##0.00 ₺';
export const CURRENCY_FORMAT8 = '#,##0.00000000 ₺';
export const CURRENCY_FORMAT6 = '#,##0.000000 ₺';

/**
 * Excel (OpenXML) sayı biçim kodu. Excel'de literal karakterler tırnak içinde
 * olmak zorunda; tırnaksız '₺' biçimi geçersiz sayıp hücreyi boş gösteriyor.
 * Yalnızca xlsx aktarımında kullanılır, ekran biçimi CURRENCY_FORMAT'tır.
 */
export const CURRENCY_EXCEL_FORMAT = '#,##0.00 "₺"';
